/* eslint-disable no-shadow */
// eslint-disable-next-line sort-imports
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { http } from "@/api/index";
import { SetWindTurbinesPF } from "@/stores/actions/WindParkKPITable";
import {
	GetWindTurbinesPerformanceFactorList,
	GetWindTurbinesPerformanceFactorListError,
	GetWindTurbinesPerformanceFactorListSuccess,
} from "@/stores/actions/WindTurbinesPerformanceFactor";

const state = {
	status:         FetchStatus.Init,
	successMessage: "",
	errorMessage:   "",
	data:           {},
	PFArray:        [],
};

const Qs = require("qs");

const missingDataError = "Não há dados no período selecionado!";
const missingDataMessage = "Não foi possível calcular o fator de desempenho no período selecionado.";
const badDataError = "Ocorreu um problema.";
const badDataMessage = "Ocorreu um problema na leitura dos dados. Já estamos trabalhando para resolver o problema!";

const actions = {
	[GetWindTurbinesPerformanceFactorList]: ({ commit, dispatch }, monitoringElementsIds) =>
	{
		commit(GetWindTurbinesPerformanceFactorList);
		const parameters = {};
		parameters.monitoringElementsIds = monitoringElementsIds;

		http.get("/WindTurbinesPerformanceFactor", {
			params:           parameters,
			paramsSerializer: params => Qs.stringify(params,
				{ encode: false }),

		})
			.then((resp) =>
			{
				dispatch(SetWindTurbinesPF, resp.data);
				commit(GetWindTurbinesPerformanceFactorListSuccess, resp.data);
			})
			.catch((error) =>
			{
				commit(GetWindTurbinesPerformanceFactorListError, error);
			});
	},
};
const mutations = {
	[GetWindTurbinesPerformanceFactorList]: (state) =>
	{
		state.badData = false;
		state.status = FetchStatus.Loading;
	},
	[GetWindTurbinesPerformanceFactorListSuccess]: (state, data) =>
	{
		state.badData = false;
		state.performanceFactor = data;
		state.status = FetchStatus.Loaded;
	},
	[GetWindTurbinesPerformanceFactorListError]: (state, error) =>
	{
		state.errorMessage = (error.status === 400 ? missingDataMessage : badDataMessage);
		state.errorHead = (error.status === 400 ? missingDataError : badDataError);
		state.error = error.response;
		state.performanceFactor = [];
		state.status = FetchStatus.Error;
	},
};

export default {
	state,
	actions,
	mutations,
};
